import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

interface UseGoogleTagManagerParams {
  gtmIdByUrl: Record<string, string>;
}

export const useGoogleTagManager = ({
  gtmIdByUrl,
}: UseGoogleTagManagerParams): void => {
  useEffect(() => {
    for (const url in gtmIdByUrl) {
      if (document.baseURI.match(new RegExp(url, 'i'))) {
        TagManager.initialize({ gtmId: gtmIdByUrl[url] });
        break;
      }
    }
  }, [gtmIdByUrl]);
};
